import { AnyAction } from "redux";
import {
  FETCH_HOME_PAGE_ERROR,
  FETCH_HOME_PAGE_SUCCESS,
  REQUEST_FETCH_HOME_PAGE,
} from "redux/actions/pages/home";

const defaultState = {
  data: {},
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_FETCH_HOME_PAGE:
      return {
        ...state,
        loading: true,
      };
    case FETCH_HOME_PAGE_SUCCESS:
      return {
        data: action.home,
        error: null,
        loading: false,
      };
    case FETCH_HOME_PAGE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
